import { RefObject, useEffect } from 'react'

interface Options {
  containerRef: RefObject<HTMLElement>
  onNearBottom: () => void
  enabled?: boolean
  threshold?: number
}

export const useInfiniteScroll = ({
  containerRef,
  onNearBottom,
  enabled = true,
  threshold = 1.01,
}: Options) => {
  useEffect(() => {
    if (!enabled) return

    const container = containerRef.current
    if (!container) return

    const onScroll = () => {
      const { scrollTop, scrollHeight, offsetHeight } = container
      if (scrollTop === 0) return

      const isNearBottom = Math.abs((scrollHeight - offsetHeight) / scrollTop) < threshold

      if (isNearBottom) onNearBottom()
    }

    container.addEventListener('scroll', onScroll)

    return () => container.removeEventListener('scroll', onScroll)
  }, [containerRef.current, enabled, onNearBottom, threshold])
}
